<div class="modal-header"><h2 class="modal-title">Apply Credit</h2></div>
<div class="modal-body">
    <dx-form [colCount]="1" validationGroup="applyCreditValidationGroup">
        <dxi-item [label]="{ text: 'Credit' }">
            <div *dxTemplate>
                <dx-select-box
                    [(value)]="creditId"
                    [dataSource]="credits"
                    valueExpr="id"
                    [displayExpr]="creditDisplayExpr"
                    [disabled]="credits.length === 0"
                    (onValueChanged)="onCreditChanged()"
                >
                </dx-select-box>
            </div>
            <dxi-validation-rule type="required" message="Please select a credit"></dxi-validation-rule>
        </dxi-item>
        <dxi-item [label]="{ text: 'Invoice' }">
            <div *dxTemplate>
                <dx-select-box
                    [(value)]="paymentLineId"
                    [dataSource]="paymentLines"
                    valueExpr="id"
                    [displayExpr]="lineDisplayExpr"
                    [disabled]="paymentLines.length === 0"
                    (onValueChanged)="onLineChanged()"
                >
                </dx-select-box>
            </div>
            <dxi-validation-rule type="required" message="Please select an invoice"></dxi-validation-rule>
        </dxi-item>
        <dxi-item [label]="{ text: 'Amount to Apply' }">
            <div *dxTemplate>
                <dx-number-box [(value)]="amount" [format]="{ type: 'currency', precision: 2 }" [step]="0"> </dx-number-box>
            </div>
            <dxi-validation-rule type="required" message="Required"></dxi-validation-rule>
            <dxi-validation-rule
                type="custom"
                [validationCallback]="validateAmount"
                [reevaluate]="true"
                message="Amount must be greater than $0 and cannot exceed the credit's available balance or the invoice's remaining balance"
            ></dxi-validation-rule>
        </dxi-item>
    </dx-form>

    <div *ngIf="credits.length === 0" class="text-danger">This dealer has no available credits.</div>
    <div *ngIf="paymentLines.length === 0" class="text-danger">There are no invoices eligible for a credit to be applied to.</div>
</div>

<div class="modal-footer">
    <button class="btn btn-success" (click)="apply()" [disabled]="!creditId || !paymentLineId">Apply</button>
    <button class="btn btn-default" (click)="close()">Cancel</button>
</div>
